import { noticeNewType } from "@/api/request/user";
export const notice = {
  state: {
    // 新消息内容
    newNoticeInfo: {} as noticeNewType,
    newNoticeDialog: false as boolean,
  },
  getters: {},
  mutations: {
    SET_INFO: (state: any, data: noticeNewType) => {
      state.newNoticeInfo = data;
    },
    SET_NEW_NOTICE_DIALOG: (state: any, status: boolean) => {
      state.newNoticeDialog = status;
    },
  },
  actions: {
    PostMessage({ commit }: any, data: noticeNewType) {
      commit("SET_INFO", data);
      commit("SET_NEW_NOTICE_DIALOG", true);
    },
  },
};
